export default "__VITE_ASSET__4tab5zFp__"